import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_APPARATO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolApparatoState extends EntityState<IID_OL_APPARATO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_APPARATO })
@InterfaceDataStore(InterfaceName.APPARATO)
export class IIDolApparatoStore extends EntityStore<IIDolApparatoState> {
  constructor() {
    super([]);
  }
}
